<template>
  <div class="login-page">
    <div class="row">

      <div class="col-md-4 col-sm-6 col-lg-3 center-block">
        <div class="card">
          <div class="card-block">
            <div class="text-center mt-3">
              <img src="../assets/img/logo.png" height="52" alt="logo">
            </div>

            <h4 class="text-muted text-center font-18 mt-3"><b>Verificar cuenta</b></h4>

            <div class="p-3">
              <div class="alert alert-danger p-3" role="alert" v-if="error">{{ error }}</div>
              <div class="alert alert-success p-3" role="alert" v-if="sendingActivationCode">Enviando verificación...</div>
              <div class="alert alert-success p-3" role="alert" v-if="successMessage">{{ successMessage }}</div>

              <div class="form-group" v-bind:class="{ 'has-danger': $v.activationCode.$error }">
                <input
                  type="email"
                  class="form-control"
                  placeholder="Email"
                  v-model="activationCode"
                  @keyup.enter="submit()"
                  @input="$v.activationCode.$touch()">
                <div class="form-control-feedback" v-if="!$v.activationCode.required && $v.activationCode.$error">El código es requerido.</div>
              </div>

              <div class="form-group text-center row m-t-20">
                <div class="col-12">
                  <button class="btn btn-primary btn-block waves-effect waves-light activation-btn" @click="submit()">Activar</button>
                </div>
              </div>
            </div>

            <div class="text-center mt-3">
              <p class="text-muted">Después de activar tu cuenta puedes volver al formulario de ingreso:</p>
              <router-link to="/login" class="text-primary">Ingresar</router-link>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators'
  import { verifyAccount } from '../api'

  export default {
    name: 'verify-account',

    data () {
      return {
        activationCode: this.$route.params.activationCode,
        sendingActivationCode: false,
        successMessage: '',
        error: ''
      }
    },


    validations: {
      activationCode: {
        required
      }
    },


    methods: {

      submit () {
        this.error = null

        this.$v.activationCode.$touch()

        if(!this.$v.activationCode.$error) {

          $('.activation-btn').attr('disabled', true);

          this.sendingActivationCode = true

            verifyAccount(this.activationCode)
              .then((response) => {

                this.sendingActivationCode = false;

                if (!response.body.success) {
                  this.error = response.body.message
                  this.successMessage = null
                } else {
                  this.successMessage = response.body.message
                  this.error = null
                }

                $('.activation-btn').attr('disabled', false);

              })
              .catch(error => {

                this.sendingActivationCode = false
                this.error = 'Ha ocurrido un error mientras se procesaba su solicitud. Intentelo nuevamente mas tarde.';
                $('.activation-btn').attr('disabled', false);

              });

        }
      }
    }

  }
</script>

<style scoped>
  .login-page{
    margin-top: 9.5%;
  }
  .center-block {
    float: none;
    margin-left: auto;
    margin-right: auto;
  }
</style>



// WEBPACK FOOTER //
// src/screens/VerifyAccountScreen.vue